export enum FederalLawCodesEnum {
  FZ_28 = '28-ФЗ',
  FZ_68 = '68-ФЗ',
  FZ_131 = '131',
  FZ_170 = '170-ФЗ',
  FZ_184 = '184',
  FZ_248 = '248',
  FZ_294 = '294',
  FZ_414 = '414',
}
